/** Query keys of searches ("zoekopdrachten", the runs API). Owner: candidates. */
export const runKeys = {
  all: ['runs'] as const,
  /** `GET /api/candidates/:id/runs`: the search history of one candidate. */
  byCandidate: (candidateId: string) => ['runs', 'candidate', candidateId] as const,
  details: () => ['runs', 'detail'] as const,
  /** `GET /api/runs/:id`. */
  detail: (runId: string) => ['runs', 'detail', runId] as const,
  /** `GET /api/runs/:id/vacancies` (the "Afgevallen" detail) with its filters. */
  vacancies: (runId: string, filters: object) =>
    ['runs', 'detail', runId, 'vacancies', filters] as const,
  /** `POST /api/candidates/:id/runs/estimate` (a read in disguise). */
  estimate: (candidateId: string, params: object) =>
    ['runs', 'estimate', candidateId, params] as const,
};
